import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "outliersTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Saver ID"),
          _createElementVNode("th", null, "Actual IRR"),
          _createElementVNode("th", null, "Benchmark IRR (%)"),
          _createElementVNode("th", null, "Remarks")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outliers, (outlier) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: outlier.dataId
        }, [
          _createElementVNode("td", null, _toDisplayString(outlier.dataId), 1),
          _createElementVNode("td", null, _toDisplayString(outlier.irr), 1),
          _createElementVNode("td", null, _toDisplayString(outlier.benchmarkIrr), 1),
          _createElementVNode("td", null, _toDisplayString(outlier.reason), 1)
        ]))
      }), 128))
    ])
  ]))
}